// Provide both the container for the errors (ErrorsView) and the individual
// errors themselves (ErrorView)

import Backbone from 'lib/backbone';
import FormError from 'app/FormError';
import templates from 'generated/compiled_handlebars_templates';

var _ = Backbone._;

export default {
  errors_view: Backbone.View.extend({
    __name__: 'InlineErrorView',
    template: templates.errors,
    className: 'at-error-console',
    events: {
      'click a.at-dismiss': 'close',
      'click .at-error': 'focusError'
    },
    initialize: function () {
      // Per instance; the prototype-level arrays would be shared across every form on the page
      this.fieldErrors = [];
      this.nonFieldErrors = [];
      this.serverErrors = [];
      this.fullWidthErrors = [];
      this.listeningTo = [];
    },
    renderFeedback: function (feedback) {
      var allErrors = feedback || this.options.formview.errors();
      if (!_.isArray(allErrors)) {
        /* jshint -W109 */
        console.warn("Errors isn't array! Errors is: " + JSON.stringify(allErrors));
        /* jshint +W109 */
        allErrors = [];
      }

      if (this.serverErrors.length) {
        allErrors = _.uniq(allErrors.concat(this.serverErrors));
      }

      // Separate out errors with fields into fieldErrors, and put the rest in nonFieldErrors
      this.fieldErrors = [];
      this.nonFieldErrors = [];
      _.each(allErrors, _.bind(function (error) {
        if (_.isObject(error) && error.field) {
          this.fieldErrors.push(error);
        } else {
          this.nonFieldErrors.push(error);
        }
      }, this));

      // Only iterate over fieldErrors for listening
      _.each(this.fieldErrors, _.bind(function (error) {
        this.listenToOnce(error.field, 'valid', function () {
          var errorIndex = _.indexOf(this.fieldErrors, error);
          if (errorIndex !== -1) {
            this.fieldErrors.splice(errorIndex, 1);
          }
          this.handleMultistep();
        });
        this.listeningTo.push(error.field);
      }, this));

      this.render().focusError();

      return this.errors();
    },
    clearFeedback: function () {
      return this.clear();
    },
    focusError: function (e) {
      var alerts = this.$('.at-alert.at-error');
      if (e) {
        // Clicked a message in the banner. The banner renders fullWidthErrors in order,
        // so the element index maps onto that list.
        e.preventDefault();
        var errorIndex = this.$(e.currentTarget).index();
        var clicked = this.fullWidthErrors[errorIndex];
        if (_.isObject(clicked) && clicked.field) {
          this.focusField(clicked.field);
        } else if (alerts[errorIndex]) {
          alerts[errorIndex].focus();
        }
      } else if (this.fieldErrors && this.fieldErrors.length > 0) {
        this.focusField(this.fieldErrors[0].field);
      } else if (this.nonFieldErrors && this.nonFieldErrors.length > 0) {
        // some error divs don't come with fields (like validation errors).
        // making sure this is an else if so it doesn't get in the way of the cc focus logic
        if (alerts[0]) {
          alerts[0].focus();
        }
      }

      return this;
    },
    focusField: function (field) {
      var stepIdx = 0;
      // find the correct step and set that step
      if (field.name === 'PaymentInformation') {
        stepIdx = field.def && field.def.step || 0;
      } else {
        stepIdx = field.parent && field.parent.def && field.parent.def.step || 0;
      }

      if (this.options.formview.multistep) {
        if (stepIdx) {
          this.options.formview.setStep(stepIdx);
        } else if (field.parent && field.parent.name) {
          this.options.formview.setStepByName(field.parent.name);
        }
      }

      field.focus();
      return this;
    },
    close: function (e) {
      if (e) {
        e.preventDefault();
        // Don't let the click bubble to the .at-error focusError handler
        e.stopPropagation();
      }
      var el = this.$(e.currentTarget).parent();
      // The banner renders fullWidthErrors in order, so the element index maps onto that list
      var errorIndex = el.index();
      var error = this.fullWidthErrors[errorIndex];
      this.fullWidthErrors.splice(errorIndex, 1);

      if (_.isObject(error) && error.field) {
        // Dismissing a field's message: drop it from the tracked errors, stop waiting on the
        // field, and clear its inline error styling
        var field = error.field;
        this.fieldErrors = _.without(this.fieldErrors, error);
        this.stopListening(field);
        this.listeningTo = _.without(this.listeningTo, field);
        field.clearFeedback();
        if (this.fieldErrors.length) {
          this.fieldErrors[0].field.focus();
        }
      } else {
        var nonFieldIndex = _.indexOf(this.nonFieldErrors, error);
        if (nonFieldIndex !== -1) {
          this.nonFieldErrors.splice(nonFieldIndex, 1);
        }
      }

      el.remove();
      return this.handleMultistep();
    },
    handleMultistep: function () {
      if (this.options.formview.multistep) {
        // Check the combined lengths of fieldErrors and nonFieldErrors
        if (this.fieldErrors.length === 0 && this.nonFieldErrors.length === 0) {
          this.options.formview.$('.at-step.active.invalid').removeClass('invalid valid');
          this.serverErrors = [];
        }
      }
      return this;
    },
    clear: function () {
      this.$el.empty();
      this.stopListeningToErrors();
      // Clear fieldErrors, nonFieldErrors, serverErrors, and the rendered banner list
      this.fieldErrors = [];
      this.nonFieldErrors = [];
      this.serverErrors = [];
      this.fullWidthErrors = [];
      return this;
    },
    val: function () {
      return {};
    }, // Hack. This isn't a form element, but we assume all subviews are.
    errors: function () {
      return [];
    }, // Hack. This isn't a form element, but we assume all subviews are.
    setFullWidthError: function (errors) {
      // Merge errors into the full width banner rather than replacing it, so that several fields
      // that can't render inline (e.g. multiple required checkboxes) all show up.
      // Errors that belong to a field replace any banner entries already shown for that field.
      errors = _.compact(_.isArray(errors) ? errors : [errors]);
      if (!errors.length) {
        return this;
      }

      var fields = _.compact(_.map(errors, function (error) {
        return error.field;
      }));
      this.fullWidthErrors = _.reject(this.fullWidthErrors, function (existing) {
        return existing.field && _.includes(fields, existing.field);
      });

      _.each(errors, _.bind(function (error) {
        var isDuplicate = _.some(this.fullWidthErrors, function (existing) {
          return String(existing) === String(error) && (existing.field || null) === (error.field || null);
        });
        if (!isDuplicate) {
          this.fullWidthErrors.push(error);
        }
      }, this));

      return this.renderFullWidthErrors();
    },
    clearFullWidthErrorsForField: function (field) {
      // Remove a field's entries from the banner once it is valid again
      var remaining = _.reject(this.fullWidthErrors, function (error) {
        return error.field === field;
      });
      if (remaining.length !== this.fullWidthErrors.length) {
        this.fullWidthErrors = remaining;
        this.renderFullWidthErrors();
      }
      return this;
    },
    renderFullWidthErrors: function () {
      this.$el.html(this.template({ messages: this.fullWidthErrors }));
      return this;
    },
    setServerErrors: function (server_errors) {
      this.serverErrors = _.reduce(server_errors, _.bind(function (memo, error) {
        var props = _(error.properties).without('customerKey', 'ccInfoKey');
        if (props.size() === 0) {
          // An error that names no properties is form-level, so show it in the banner. Errors that only
          // name the stored card keys stay hidden.
          if (_.isEmpty(error.properties) && error.text) {
            memo.push(error.text);
          }
          return memo;
        }

        var fieldView = null;
        var fieldName = null;
        var isPaymentError = false;
        props.each(_.bind(function (prop) {
          fieldName = prop
            .replace(/\.Value$/, '')
            .replace(/DirectConnectSpecific/, 'Account')
            .replace(/Expiration(Month|Year)/, 'ExpirationDate');

          isPaymentError = isPaymentError || fieldName === 'Account'
            || fieldName === 'ExpirationDate' || fieldName === 'PaymentInformation';

          fieldView = this.options.formview.getField(fieldName);

          // break loop if field is found
          if (fieldView) {
            return false;
          }
        }, this));

        if (isPaymentError) {
          this.options.formview.$('.change-account').trigger('click');
        }

        var accountIndex = props.indexOf('DirectConnectSpecific');
        if (accountIndex >= 0) {
          var temp = props.value();
          temp[accountIndex] = 'Account';
          props = _(temp);
        }

        if (props.size() && error.text) {
          if (props.includes('Account')) {
            error.text = error.text.replace(/^Account/i, 'Credit Card Number');
          } else if (props.includes('ExpirationMonth')) {
            error.text = error.text.replace(/month/i, 'Month');
          } else if (props.includes('ExpirationYear')) {
            error.text = error.text.replace(/year/i, 'Year');
          } else {
            error.text = error.text;
          }

          if (fieldView) {
            var fieldError = new FormError(error.text, fieldView);
            memo.push(fieldError);
          } else {
            memo.push(error.text);
          }
        }

        if (isPaymentError && fieldView) {
          if (fieldView.parent && fieldView.parent.def) {
            fieldView.parent.def.required = true;
          }

          if (fieldView.def) {
            fieldView.def.required = true;
          }
        }

        return memo;
      }, this), []);
      return this;
    },
    stopListeningToErrors: function () {
      function stopListeningToError(field) {
        /*jshint -W040 */
        this.stopListening(field);
        /*jshint +W040 */
      }

      _.each(this.listeningTo, _.bind( stopListeningToError, this));
      this.listeningTo = [];
      return this;
    },
    render: function () {
      // Render field errors from the server inline on their fields. Non-server inline errors are rendered
      // by their views. A field can have several server errors, and each render replaces the last, so
      // render each field once with all of its errors.
      var serverFields = [];
      var serverFieldErrors = [];
      _.each(this.fieldErrors, _.bind(function (error) {
        if (_.indexOf(this.serverErrors, error) !== -1) {
          var fieldIndex = _.indexOf(serverFields, error.field);
          if (fieldIndex === -1) {
            serverFields.push(error.field);
            serverFieldErrors.push([error]);
          } else {
            serverFieldErrors[fieldIndex].push(error);
          }
        }
      }, this));
      _.each(serverFields, function (field, fieldIndex) {
        field.renderFeedbackWithErrors(serverFieldErrors[fieldIndex]);
      });

      // Non-field errors are recomputed on every renderFeedback, so drop the previous set from the
      // banner. Field errors stay until their field clears them.
      this.fullWidthErrors = _.filter(this.fullWidthErrors, function (error) {
        return !!error.field;
      });

      // If inline errors are enabled, don't vomit the errors to the top.
      if (this.options.formview.options.parent_tag.options.inline_error_display !== 'true' ||
        this.serverErrors.length > 0) {
        this.setFullWidthError(this.nonFieldErrors);
      }
      return this.renderFullWidthErrors();
    },
  })
};
